import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ExperssionSeries = ({effect, currentCycles}) => { 
    let [selected, setSelected] = useState(undefined);
    let [value, setValue] = useState(undefined);

    let indices = [];
    for (let id in currentCycles) {
        if (effect.tidals[0]) {
            let cycle = effect.tidals[0].cycle.flat(16).map(x => x.id);
            indices.push(cycle.indexOf(id) % effect.expressionSeries.length);
        }
    }
    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [value, setSelected]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            effect.expressionSeries[selected] = value;
            setSelected(undefined);
        }
    }, [value, setSelected, selected]);

    useEffect(() => {
        if (selected !== undefined) {
            setValue(effect.expressionSeries[selected]);
        }
    }, [selected, setValue]);

    if (selected !== undefined) {
        return (
            <div className="expression-series">
              <input value={value} onChange={e => setValue(e.target.value)} type="text"/>
            </div>);
    }

    return (
        <div className="expression-series">
          {effect.expressionSeries.map(

             (x,i) =>
                  <div
                    onClick={() => 
                             setSelected(i)}
                    className={indices.includes(i) ? "expression selected" : "expression"}>
                    {x}th
                  </div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      currentCycles: props.effect.tidals && props.effect.tidals[0] &&
          props.effect.tidals[0].currentCycles
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExperssionSeries);
